import FileInfo from '../containers/FileInfo';

async function retrieveFileInfo(id: number){
  const path = '/api/asebi/fileinfos/{id}'.replace('{id}', id.toString());
  const resp = await fetch(path);
  const json = await resp.json();

  const data = new FileInfo();
  data.load(json);
  return data;
}

export default retrieveFileInfo;
